import { IconPack, library } from "@fortawesome/fontawesome-svg-core";
import { fal } from "@vintecc/pro-light-svg-icons";
import "@vintecc/components/style.css";
import "@vintecc/config-editor/style.css";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { StrictMode } from "react";
import { initializeGlobalErrorHandlers } from "@/services/errorHandling/globalErrorHandler";
import { preloadInitialCulture } from "@/services/culture/bootstrap";
import { registerServiceWorker } from "@/sw-register";

// TODO: only add the necessary icons
library.add(fal as IconPack);

// Initialize global error handlers before rendering
initializeGlobalErrorHandlers();

// Register the session service worker (owns JWT renewal / proactive refresh).
registerServiceWorker();

const bootstrap = async () => {
  const initialCulture = await preloadInitialCulture();

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App initialCulture={initialCulture} />
    </StrictMode>,
  );
};

void bootstrap();
